export function UserImportRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.UserImport', {
		url: '/admin/users/import',
		controllerAs: 'vm',
		controller: UserImportCtrl,
		templateUrl: '/ng/hub/User/Import/UserImportCtrl.html?' + window.BUILD,
		resolve: {
			$title: () => 'Import Users',
		},
	});
}

export class UserImportCtrl {
	constructor(Api, $stateParams) {
		'ngInject';
		this.Api = Api;
		this.files = [];
		this.state = 'waiting';
		this.onlyContacts = !!$stateParams.onlyContacts;
		this.sendEmail = !this.onlyContacts;
		this.handleReport = this.handleReport.bind(this);
		this.handlePreview = this.handlePreview.bind(this);
	}

	$onInit() {
		this.allowedExtensions = ['xls', 'xlsx', 'csv', 'ods'];
	}

	importFile(file) {
		this.fileObject = file.listItem;
		this.previewFile();
	}

	importPaste(evt) {
		evt.preventDefault();
		this.pasteData = evt.clipboardData.getData('Text');
		this.previewPaste();
	}

	cancel() {
		this.files = [];
		this.state = 'waiting';
		this.pasteData = undefined;
		this.fileObject = undefined;
		this.note = undefined;
	}

	previewFile() {
		this.state = 'processing';
		this.Api.post('/users/import/preview/spreadsheet', {
			file: this.fileObject.href,
			role: this.onlyContacts ? 'observer' : undefined,
		}).then(this.handlePreview);
	}

	previewPaste() {
		this.state = 'processing';
		this.Api.post('/users/import/preview/paste', {
			data: this.pasteData,
			role: this.onlyContacts ? 'observer' : undefined,
		}).then(this.handlePreview);
	}

	submit() {
		this.state = 'processing';
		if (this.pasteData) {
			this.Api.post('/users/import/paste', {
				data: this.pasteData,
				note: this.note || undefined,
				role: this.onlyContacts ? 'observer' : undefined,
				send_email: !!this.sendEmail,
			}).then(this.handleReport);
		} else if (this.fileObject) {
			this.Api.post('/users/import/spreadsheet', {
				file: this.fileObject.href,
				note: this.note || undefined,
				role: this.onlyContacts ? 'observer' : undefined,
				send_email: !!this.sendEmail,
			}).then(this.handleReport);
		}
	}

	handleReport(report) {
		this.state = report ? 'done' : 'error';
		this.note = '';
		this.report = report;
	}

	handlePreview(data) {
		this.state = 'confirm';
		this.previewRows = data.rows;
		this.previewTotal = data.total;
	}
}
